import { Stack } from '@mantine/core';
import { CardContainer } from '../../cardContainer';
import { IconUsers } from '@tabler/icons';
import { IListItemProps, ListItem } from '../../listItem';
import { ROUTES } from '@/containers/routes/constants';
import { useTranslation } from 'react-i18next';
import { FC } from 'react';
import { useGetUsersQuery } from '@/entities/admin-app/users/api';

interface IUsersSectionProps {
  filialId?: number;
}

export const UsersSection: FC<IUsersSectionProps> = ({ filialId }) => {
  const { t } = useTranslation();

  const { data: usersData } = useGetUsersQuery({
    Count: 20,
    Offset: 0,
    SortOrder: 0,
    SortField: 0,
    Filters: {},
    Query: '',
    FilterConditions: []
  });

  const usersMenu: IListItemProps = {
    withCheck: false,
    items: [
      { name: t('users.list'), link: ROUTES.users.fullPath },
      { name: t('filials.modules.addUser'), link: '/create-user' },
      {
        name: t('filials.linkInvite'),
        link: `${ROUTES.filials.fullPath}/${filialId}/${ROUTES.filials.edit.pages.auth.invite}`
      },
      {
        name: t('filials.configureLdap'),
        link: `${ROUTES.filials.fullPath}/${filialId}/${ROUTES.filials.edit.pages.auth.ldap}`
      }
    ]
  };

  return (
    <CardContainer
      sectionName={t('navigation.users')}
      counter={usersData && usersData.TotalCount}
      Icon={IconUsers}
    >
      <Stack gap="7px" sx={{ width: '100%' }}>
        <ListItem items={usersMenu.items} withCheck={usersMenu.withCheck} />
      </Stack>
    </CardContainer>
  );
};
